import axios from "@/axios";
import baseUrl from "../../util/backend";
export default {
  namespaced: false,
  state: {
    user_id: null,
    token: null,
    refreshToken: null,
  },
  mutations: {
    setUser(state, payload) {
      state.user_id = payload.user_id;
      state.token = payload.access_token;
      state.refreshToken = payload.refresh_token;
    },
  },
  actions: {
    async login({ commit }, payload) {
      try {
        const res = await axios.post(`${baseUrl()}/admin/login`, {
          email: payload.email,
          password: payload.password,
        });
        commit("setUser", res.data.data);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${res.data.data.access_token}`;
        localStorage.setItem("user", res.data.data.user_id);
        localStorage.setItem("token", res.data.data.access_token);
        localStorage.setItem("refreshToken", res.data.data.refresh_token);
      } catch (err) {
        if (err.response) {
          if (err.response.data.message === "Invalid token")
            throw "Invalid user";
          else {
            throw err.response.data.message;
          }
        } else {
          throw err.message;
        }
      }
    },
    logout({ commit }) {
      delete axios.defaults.headers.common["Authorization"];
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      commit("setUser", {
        user_id: null,
        access_token: null,
        refresh_token: null,
      });
    },
    async checkUser({ commit }) {
      const id = localStorage.getItem("user");
      const token = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refreshToken");

      if (id && token && refreshToken) {
        commit("setUser", {
          user_id: id,
          access_token: token,
          refresh_token: refreshToken,
        });
        localStorage.setItem("user", id);
        localStorage.setItem("token", token);
        localStorage.setItem("refreshToken", refreshToken);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      }
    },
  },
  getters: {
    isAuth: (state) => !!state.token,
  },
};
